// JSON API client. Every failure becomes an ApiError with a message that is
// safe and useful to show the learner.
export class ApiError extends Error {
  constructor(status, code, message, data = {}) {
    super(message);
    this.status = status;
    this.code = code;
    this.data = data;
  }
}

export async function api(path, { method = 'GET', body } = {}) {
  let res;
  try {
    res = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body !== undefined ? { 'content-type': 'application/json' } : {},
      body: body !== undefined ? JSON.stringify(body) : undefined,
      cache: 'no-store',
    });
  } catch {
    throw new ApiError(0, 'offline', "You're offline. Your progress is still saved on this device.");
  }
  let data = null;
  try {
    data = await res.json();
  } catch {
    // Non-JSON response (proxy error page etc.).
  }
  if (!res.ok) {
    throw new ApiError(res.status, (data && data.error) || 'http',
      (data && data.message) || 'Something went wrong. Please try again.', data || {});
  }
  return data;
}
